<template>
  <div style="display: inline-block;">
    <template v-if="isEdit">
      <div class="tag-box-edit">
        <div style="display: flex;flex-direction: row;gap: 4px;align-items: center;">
          <input
            v-model="data"
            class="input-box"
            :required="true"
            type="text"
            style="height:20px"
          />
          <div @click="summitQuestion">
            <img src="/static/img/assets/welcome/correct.svg" />
          </div>
          <div @click="changeIsEdit">
            <img src="/static/img/assets/welcome/X.svg" />
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="tag-box">
        <div
          style="display: flex;flex-direction: row;gap: 4px;align-items: center;cursor:default;"
          @click="changeIsEdit"
        >
          <typography :label="`+ เพิ่ม`" color="rgba(189, 189, 189, 1)" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Typography from '@/components/elements/Typography'

import api from '@/api'
import moment from 'moment'
const dict = {
  en: {
    custom: {
      intentName: {
        excluded: 'Duplicate Conversation Name',
        excludednew: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      intentName: {
        excluded: 'ชื่อบทสนทนาซ้ำ',
        excludednew: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      intentName: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ',
        excludednew: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}
export default {
  data: function() {
    return {
      isEdit: false,
      result: '',
      data: '',
      timestamp: moment().format('x'),
      vtags: []
    }
  },
  components: {
    Typography
  },
  props: {
    type: String,
    index: Number,
    normal: Array,
    keyword: Array,
    exactly: Array,
    startwith: Array,
    endwith: Array,
    startandendwith: Array,
    excludedIntentName: {
      type: String,
      default: ''
    },
    value: Object
  },

  mounted: function() {
    let vm = this

    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)

    vm.intent = Object.assign({}, vm.value)
    if (!vm.intent.postidlist) {
      vm.intent.postidlist = ''
    } else {
      var includes = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'includes', includes)
    }
    if (vm.intent.fb_val || vm.intent.line_val) {
      this.showMultipleChannel = true
      this.fb_messages = JSON.parse(vm.intent.fb_val)
      this.line_messages = JSON.parse(vm.intent.line_val)
    }
    this.timestamp = moment().format('x')

    if (vm.isCommentToInbox) {
      vm.remaining_reply = vm.intent.remaining_reply
      vm.notreplysameperson = vm.intent.notreplysameperson
      vm.isremainingreply = vm.intent.remaining_reply != null
    }

    if (!vm.intent.exceptpostidlist) {
      vm.intent.exceptpostidlist = ''
    } else {
      var excludes = []
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'excludes', excludes)
    }
    vm.cached_intent = Object.assign({}, vm.value)

    if (vm.intent.starttime) {
      var startTime = moment(vm.intent.starttime)
      vm.startDate = startTime.format('YYYY-MM-DD')
      vm.startTime = startTime.format('HH:mm')
    }
    if (vm.intent.endtime) {
      var endTime = moment(vm.intent.endtime)
      vm.endDate = endTime.format('YYYY-MM-DD')
      vm.endTime = endTime.format('HH:mm')
    }

    vm.intents = vm.excludedIntentName.split(',')
    vm.intents.push('comment')
    vm.intents.push('{default}')
    vm.intents.push('{welcome}')
    vm.intents.push('{default_comment_to_inbox}')

    vm.intent.onlytime = vm.intent.onlytime ? vm.intent.onlytime : false

    if (vm.isCommentToInbox && !vm.isLiveStream) {
      vm.isReplyComment = true
      vm.intent.context_in = 'comment'
    } else if (vm.isLiveStream) {
      vm.intent.context_in = 'facebooklive'
    }
    var names = []
    if (vm.type === 'edit' && vm.excludedIntentName && vm.excludedIntentName !== '' && vm.intent) {
      names = vm.intents
      $.each(names, function(index, name) {
        if (name === vm.intent.intentname) {
          names.splice(index, 1)
          return false
        }
      })

      names = names.map(el => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    } else {
      names = vm.intents.map(el => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    }
    if (vm.value.context_in === 'comment') {
      if (vm.value.a_type === 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          var message = JSON.parse(vm.value.a_val)
          if (message[0][0].type === 'text') {
            vm.messages = [
              [
                {
                  type: 'responsepost',
                  replyinbox: true,
                  replycomment: false,
                  hidecomment: false,
                  responseinbox: [
                    {
                      type: 'text',
                      text: message[0][0].text
                    }
                  ],
                  responsecomment: [
                    {
                      type: 'text',
                      text: ''
                    }
                  ]
                }
              ]
            ]
          } else if (message[0][0].type === 'responsepost') {
            vm.messages = message
          }
        } else {
          vm.messages = [
            [
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: vm.value.a_val
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ]
          ]
        }
      } else {
        vm.messages = [
          [
            {
              type: 'responsepost',
              replyinbox: true,
              replycomment: false,
              hidecomment: false,
              responseinbox: [
                {
                  type: 'text',
                  text: vm.value.a_val
                }
              ],
              responsecomment: [
                {
                  type: 'text',
                  text: ''
                }
              ]
            }
          ]
        ]
      }
    } else if (vm.value.a_type === 'json') {
      if (vm.isJsonParseable(vm.value.a_val)) {
        vm.messages = JSON.parse(vm.value.a_val)
      } else {
        vm.messages = [[]]
      }
    } else {
      if (vm.value.a_val === '{welcome_message}') {
        vm.messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (vm.value.a_type === 'text') {
        var newGroup = []
        var group = vm.value.a_val.split('||')
        $.each(group, function(index, messages) {
          var newMessage = []
          var groupMessages = messages.split('#nl')
          $.each(groupMessages, function(index, message) {
            var type = 'text'
            if (!isNaN(message)) {
              newMessage.push({
                type: 'text',
                text: message
              })
            } else if (vm.isJsonParseable(message)) {
              var messageParsed = JSON.parse(message)
              newMessage.push({
                text: messageParsed.text,
                buttons: messageParsed.buttons,
                type: 'button'
              })
            } else if (vm.isURL(message)) {
              newMessage.push({
                type: 'image',
                image_url: message
              })
            } else {
              newMessage.push({
                type: 'text',
                text: message
              })
            }
          })
          newGroup.push(newMessage)
        })
        vm.messages = newGroup
      } else if (vm.value.a_type === 'message') {
        vm.messages = [
          [
            {
              type: 'text',
              data: vm.value.a_val
            }
          ]
        ]
      } else if (vm.value.a_type === 'template') {
        vm.messages = [
          [
            {
              type: 'generic',
              data: JSON.parse(vm.value.a_val),
              ratio: vm.value.ratio == 'horizontal' ? 'horizontal' : 'square'
            }
          ]
        ]
      } else if (vm.value.a_type === 'message') {
      } else if (vm.value.a_type === 'generic') {
      } else if (vm.value.a_type === 'viewsummary') {
        vm.messages = [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    }
    if (this.selectedBot.theme == 'ticket') {
      this.ticketinit()
    }
  },
  methods: {
    changeIsEdit: function() {
        this.data = ''
      this.isEdit = !this.isEdit
    },
    updateQuestion: function() {
      this.result = ''
      var result = []
      var normal = []
      this.normal.map(function(key, index) {
        normal.push(key.text.trim())
      })
      if (normal && normal.length > 0) {
        if (this.type === 'normal') {
          normal.push(this.data)
        }
        result.push(normal.join(','))
      }else{
        if (this.type === 'normal') {
          normal.push(this.data)
          result.push(normal.join(','))
        }
      }

      var keyword = []
      this.keyword.map(function(key, index) {
        keyword.push('includes(' + key.text.trim() + ')')
      })
      if (keyword && keyword.length > 0) {
        if (this.type === 'keyword') {
          keyword.push('includes(' + this.data + ')')
        }
        result.push(keyword.join(','))
      }else{
        if (this.type === 'keyword') {
          keyword.push('includes(' + this.data + ')')
          result.push(keyword.join(','))
        }
      }

      var exactly = []
      this.exactly.map(function(key, index) {
        exactly.push('exacts(' + key.text.trim() + ')')
      })
      if (exactly && exactly.length > 0) {
        if (this.type === 'exactly') {
          exactly.push('exacts(' + this.data + ')')
        }
        result.push(exactly.join(','))
      }else{
        if (this.type === 'exactly') {
            exactly.push('exacts(' + this.data + ')')
            result.push(exactly.join(','))
        }
      }

      var startwith = []
      this.startwith.map(function(key, index) {
        startwith.push('startswith(' + key.text.trim() + ')')
      })
      if (startwith && startwith.length > 0) {
        if (this.type === 'startwith') {
          startwith.push('startswith(' + this.data + ')')
        }
        result.push(startwith.join(','))
      }else{
        if (this.type === 'startwith') {
          startwith.push('startswith(' + this.data + ')')
          result.push(startwith.join(','))
        }
      }

      var endwith = []
      this.endwith.map(function(key, index) {
        endwith.push('endswith(' + key.text.trim() + ')')
      })
      if (endwith && endwith.length > 0) {
        if (this.type === 'endwith') {
          endwith.push('endswith(' + this.data + ')')
        }
        result.push(endwith.join(','))
      }else{
        if (this.type === 'endwith') {
          endwith.push('endswith(' + this.data + ')')
          result.push(endwith.join(','))
        }
      }

      var startandendwith = []
      this.startandendwith.map(function(key, index) {
        startandendwith.push('startsendswith(' + key.text.trim() + ')')
      })
      if (startandendwith && startandendwith.length > 0) {
        if (this.type === 'startandendwith') {
          startandendwith.push('startsendswith(' + this.data + ')')
        }
        result.push(startandendwith.join(','))
      }else{
        if (this.type === 'startandendwith') {
          startandendwith.push('startsendswith(' + this.data + ')')
          result.push(startandendwith.join(','))
        }
      }
      this.result = result.join(',')
    },

    saveIntent: function() {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        intentname: vm.intent.intentname,
        q_type: vm.intent.q_type,
        q_val: this.result,
        a_type: 'json',
        a_val: vm.intent.a_val,
        ispriority: vm.intent.ispriority,
        quick_reply: vm.intent.quick_reply,
        postidlist: vm.intent.postidlist,
        exceptpostidlist: vm.intent.exceptpostidlist ? vm.intent.exceptpostidlist : '',
        isShow: true,
        intentstatus: vm.intent.intentstatus ? vm.intent.intentstatus : false,
        onlytime: vm.intent.onlytime ? vm.intent.onlytime : false,
        intentgroup: vm.intent.intentgroup ? vm.intent.intentgroup : null
      }

      if (vm.selectedBot.theme == 'ticket') {
        data.intentgroup = vm.intentgroup
      }

      if (this.showMultipleChannel) {
        data.fb_val = JSON.stringify(vm.fb_messages).replace(/ /gim, ' ')
        data.line_val = JSON.stringify(vm.line_messages).replace(/ /gim, ' ')
      }

      if (vm.$store.getters.getPackage == 'premium') {
        data.context_in = vm.intent.context_in != null ? vm.intent.context_in : ''
        data.context_out = vm.intent.context_out != null ? vm.intent.context_out : ''
        data.userstatus = vm.intent.userstatus
        data.usertags = vm.intent.usertags
        data.linenoti_status = vm.intent.linenoti_status
        data.linenoti_text = vm.intent.linenoti_text
        data.starttime = vm.startTimeFormat ? vm.startTimeFormat + moment().format('Z') : null
        data.endtime = vm.endTimeFormat ? vm.endTimeFormat + moment().format('Z') : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = vm.remaining_reply == false ? null : vm.remaining_reply
          data.notreplysameperson = vm.notreplysameperson
        }
      } else {
        data.context_in = vm.cached_intent.context_in != null ? vm.cached_intent.context_in : ''
        data.context_out = vm.cached_intent.context_out != null ? vm.cached_intent.context_out : ''
        data.userstatus = vm.cached_intent.userstatus
        data.usertags = vm.cached_intent.usertags
        data.linenoti_status = vm.cached_intent.linenoti_status
        data.linenoti_text = vm.cached_intent.linenoti_text
        data.starttime = vm.cached_intent.starttime ? vm.cached_intent.starttime : null
        data.endtime = vm.cached_intent.endtime ? vm.cached_intent.endtime : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = null
          data.notreplysameperson = false
        }
      }

      if (vm.isWelcome) {
        var welcome_answer = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
        data.a_val = JSON.stringify(welcome_answer)
      } else {
        if (vm.isCommentToInbox && !vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'comment'
          data.a_type = 'json'
        } else if (vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'facebooklive'
          data.a_type = 'json'
        } else if (data.a_type === 'json') {
          var messages = vm.checkEmptyMessage(vm.messages)

          data.a_val = JSON.stringify(messages)
        }
      }
      vm.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            vm.goToErrorInput()
            return false
          }

          if (!vm.intent.id) {
            vm.$store.dispatch('loading')
            api.addIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              data.id = response.id
              vm.$emit('input', data)
              vm.$emit('saveIntent', data)
              vm.$emit('close', null)
              vm.$store.dispatch('loading')
              vm.intent = {
                intentname: '',
                q_type: 'text',
                a_type: 'json',
                q_val: '',
                a_val: [[]],
                context_in: '',
                context_out: '',
                postidlist: '',
                exceptpostidlist: ''
              }
              vm.cached_intent = Object.assign({}, vm.intent)
            })
          } else {
            data['id'] = vm.intent.id
            vm.$store.dispatch('loading')
            api.editIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              vm.$emit('input', data)
              vm.$emit('saveIntent', data)
              vm.cached_intent = Object.assign({}, vm.intent)

              vm.$store.dispatch('loading')
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    summitQuestion: function() {
      if(this.data.includes(',')){
        this.data = ''
        this.$swal.fire({
        title:'<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
        html: `<div> ไม่สามารถใช้เครื่องหมายจุลภาค (,) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
        width:'590px',
        })
        return
      }
      if(this.data.includes('(')){
        this.data = ''
        this.$swal.fire({
        title:'<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
        html: `<div> ไม่สามารถใช้เครื่องหมายวงเล็บ ( ) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
        width:'590px',
        })
        return
      }
      if(this.data.includes(')')){
        this.data = ''
        this.$swal.fire({
        title:'<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
        html: `<div> ไม่สามารถใช้เครื่องหมายวงเล็บ ( ) ในประโยคได้ กรุณาลองใหม่อีกครั้ง </div>`,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
        width:'590px',
        })
        return
      }
      if(this.data === ''){
        this.data = ''
        this.$swal.fire({
        title:'<div style="color:background: rgba(12, 47, 83, 1);"> เกิดข้อผิดพลาด </div>',
        html: `<div> กรุณากรอกข้อความ </div>`,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
        width:'590px',
        })
        return
      }
      this.updateQuestion()
      this.saveIntent()
      this.data = ''
      this.isEdit = false
    }
  }
}
</script>
<style scoped>
.tag-box {
  background-color: #fff;
  padding: 0px 8px 0px 8px;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px dotted rgba(189, 189, 189, 1);
  color: rgba(189, 189, 189, 1);
  border-radius: 6px;
  min-width: 60px;
  text-align: center;
  height: 25px;
}

.input-box {
  height: 20px !important;
  border-bottom: none !important;
  font-family: 'Sukhumvit' !important;
}
.input-box:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}
.tag-box-edit {
  background-color: #fff;
  padding: 0px 8px 0px 8px;
  display: inline-block;
  margin-right: 8px;
  /* margin-bottom: 8px; */
  border: 1px dotted rgba(189, 189, 189, 1);
  color: black;
  border-radius: 6px;
  min-width: 60px;
  text-align: center;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/welcomemessage/BoxAddMessage.vue